import React, { ReactNode } from 'react';

import classes from './PriceInfoSection.module.scss';

type PriceInfoSectionProps = {
  /** lead-in before the name, e.g. "Subscribe to", "Pay for" */
  label: string;
  /** what the customer pays for — subscription or challenge name */
  name: ReactNode;
  /** price rows (CurrentPrice, renewal note, etc.) */
  children: ReactNode;
};

const PriceInfoSection = ({ label, name, children }: PriceInfoSectionProps) => {
  return (
    <div className={classes.container}>
      <p className={classes.title}>
        {label}&nbsp;<span className={classes.name}>{name}</span>
      </p>
      {children}
    </div>
  );
};

export { PriceInfoSection };
